import { RollResult } from '../common';
import {
  HistoryActionTypes,
  RESET_HISTORY,
  ADD_HISTORY,
  UPDATE_HISTORY,
  CLEAR_HISTORY,
  DELETE_HISTORY,
} from './types';

export function resetHistoryAction(): HistoryActionTypes {
  return {
    type: RESET_HISTORY,
  };
}

export function clearHistoryAction(): HistoryActionTypes {
  return {
    type: CLEAR_HISTORY,
  };
}

export function addHistoryAction(rollResult: RollResult): HistoryActionTypes {
  return {
    type: ADD_HISTORY,
    rollResult,
  };
}

export function updateHistoryAction(rollResult: RollResult): HistoryActionTypes {
  return {
    type: UPDATE_HISTORY,
    rollResult,
  }
}

export function deleteHistoryAction(id: string): HistoryActionTypes {
  return {
    type: DELETE_HISTORY,
    id,
  };
}
